export const relatedPulseArticles = {
  managers: [
    {
      title: 'The Hidden Time Cost of Running a Club — and How to Reduce It',
      slug: 'the-hidden-time-cost-of-running-a-club-and-how-to-reduce-it',
    },
    {
      title: '5 Ways to Get More Out of Your Club Nights',
      slug: '5-ways-to-get-more-out-of-your-club-nights',
    },
  ],
  players: [
    {
      title: 'What Your Stats Can Teach You About Your Game',
      slug: 'what-your-stats-can-teach-you-about-your-game',
    },
  ],
  pegboard: [
    {
      title: 'The Science of Court Rotations: Why Random Isn’t Always Fair',
      slug: 'the-science-of-court-rotations-why-random-isnt-always-fair',
    },
    {
      title: 'Why Fair Rotations Matter: More Games, Better Games',
      slug: 'why-fair-rotations-matter-more-games-better-games',
    },
    {
      title: 'Why Rolling Queues Don’t Deliver Fair Games',
      slug: 'why-rolling-queues-dont-deliver-fair-games',
    },
  ],
};

export const getPulsePath = (slug) => `/pulse/${slug}`;
